import React from 'react';
// @ts-ignore
import { Button } from '@els/els-react--button';
import { useDispatch } from 'react-redux';
// @ts-ignore
import Logged_Out_View from '../../assets/img/Logged_Out_View.svg';
import './logged-out-view.scss';
import { loginFlow } from '../../features/login/login-thunk';

export const LoggedOutView = () => {
    const baseClassName = 'logged-oue-view';
    const dispatch = useDispatch();
    return (
        <div className={`${baseClassName}`}>
            <img
                className={`${baseClassName}__image`}
                src={Logged_Out_View}
                alt="LoggedOutView"
            />
            <div className={`${baseClassName}__message`}>
                <p>In order to access your favorited skills please</p>
                <Button type="link" onClick={() => dispatch(loginFlow())}>
                    sign in.
                </Button>
            </div>
        </div>
    );
};
